// planoSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    planos: [],
    planoSelecionado: {},
    opcaoSelecionada: {},
    assinaturaAntiga: '',
    dadosUsuario: {},
    loading: false,
    error: null,
    respostaTroca: null,
    errorTroca: null,
};

export const planoSlice = createSlice({
    name: 'plano',
    initialState,
    reducers: {
        fetchPlanosStart: state => {
            state.loading = true;
            state.error = null;
        },
        fetchPlanosSuccess: (state, action) => {
            state.planos = action.payload;
            state.loading = false;
        },
        fetchOpcoesStart: (state, action) => {
            state.opcaoSelecionada = action.payload;
        },
        fetchPlanosFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
        setPlanoEscolhido: (state, action) => {
            state.planoSelecionado = action.payload;
        },
        salvarPlano: (state, action) => {
            state.assinaturaAntiga = action.payload;
        },
        trocarPlano: (state, action) => {
            state.respostaTroca = null;
            state.error = null;
        },
        trocarPlanoSuccess: (state, action) => {
            state.respostaTroca = action.payload;
        },
        trocarPlanoFailure: (state, action) => {
            state.errorTroca = action.payload;
        },
        consultarAssinatura: (state, action) => {
            state.error = null;
            state.loading = true;
        },
        consultarAssinaturaSuccess: (state, action) => {
            state.dadosUsuario = action.payload;
            state.loading = false;
        },
        consultarAssinaturaFailure: (state, action) => {
            state.error = action.payload;
            state.loading = false;
        },
    },
});

export const { fetchPlanosStart, fetchPlanosSuccess, fetchPlanosFailure, setPlanoEscolhido, fetchOpcoesStart, trocarPlano, trocarPlanoSuccess, trocarPlanoFailure, salvarPlano, consultarAssinatura, consultarAssinaturaSuccess, consultarAssinaturaFailure } = planoSlice.actions;

export default planoSlice.reducer;
